












import { defineComponent } from '@vue/composition-api';

const name = 'ttam-audience-size-ttp-tip';
export default defineComponent({
  props: {
    country: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      name,
    };
  },
});
